import { FC } from 'react';
import { overrideTailwindClasses } from 'tailwind-override';
import clsx from 'clsx';

import Button from 'components/atoms/Button';
import { ButtonModes } from 'constants/ButtonModes';
import { ContentNavigationSingle } from 'types/contentful/Items/ContentNavigationItem';
import { SimpleCard } from 'components/atoms/SimpleCard';

interface Props {
  className?: string;
  headerTag?: 'h2' | 'h3';
  content: ContentNavigationSingle;
}

export const ContentNavigationCardSingle: FC<Props> = ({
  className,
  headerTag: Header = 'h3',
  content,
}) => (
  <SimpleCard
    color="black"
    className={overrideTailwindClasses(clsx('flex flex-col pt-8', className))}
  >
    <Header className="mb-5 h5">{content.title}</Header>
    <p className="mb-10">{content.intro}</p>
    {content.link && (
      <Button
        className="mt-auto w-fit"
        size="small"
        mode={ButtonModes.secondaryWhite}
        href={content.link.href}
        aria-label={content.intro ?? undefined}
      >
        {content.link.text}
      </Button>
    )}
  </SimpleCard>
);
